module.exports = __webpack_public_path__ + "assets/logoPago0a227b26.png";